//@ts-ignore
import data from '../.freec/static/categories.json'
export default data
